import { PROPERTY, CTA_LABEL } from "../../data";

export const Footer = ({ onRequestPackage, onConversation }) => {
  return (
    <footer className="bg-navy-dark text-slate-300">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="font-serif text-2xl text-white">Bay Quarter Shores</div>
            <div className="label-caps text-[10px] text-water mt-1">{PROPERTY.lot} · Homesite</div>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-xs">
              {PROPERTY.acres} · {PROPERTY.zoning}
              <br />
              {PROPERTY.taxMap}
              <br />
              {PROPERTY.county}
            </p>
          </div>

          <div>
            <div className="label-caps text-[11px] text-slate-500">Explore</div>
            <div className="mt-4 grid grid-cols-2 gap-2 text-sm">
              <a href="#property" className="hover:text-white transition-colors">Property</a>
              <a href="#community" className="hover:text-white transition-colors">Community</a>
              <a href="#due-diligence" className="hover:text-white transition-colors">Due Diligence</a>
              <a href="#location" className="hover:text-white transition-colors">Location</a>
              <a href="#faq" className="hover:text-white transition-colors">FAQ</a>
            </div>
          </div>

          <div>
            <div className="label-caps text-[11px] text-slate-500">Get Started</div>
            <div className="mt-4 flex flex-col gap-3">
              <button
                data-testid="footer-request-package-btn"
                onClick={onRequestPackage}
                className="bg-water text-white rounded-full px-6 py-3 text-sm font-medium hover:bg-water-soft transition-colors"
              >
                {CTA_LABEL}
              </button>
              <button
                data-testid="footer-conversation-btn"
                onClick={onConversation}
                className="border border-slate-700 text-white rounded-full px-6 py-3 text-sm font-medium hover:bg-white/10 transition-colors"
              >
                Schedule a Property Conversation
              </button>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 text-xs text-slate-500 leading-relaxed space-y-2">
          <p>This website is provided for informational purposes only.</p>
          <p>Information has been gathered from public records, HOA correspondence, and county agencies.</p>
          <p>
            Prospective buyers should independently verify all information and conduct their own due
            diligence before purchasing. No guarantees regarding buildability, septic approval, or
            development are made.
          </p>
          <p className="pt-2 text-slate-600">© {new Date().getFullYear()} Bay Quarter Shores · Lot 17-L. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
